if (!customElements.get('fkk-team-tabs')) {
  customElements.define('fkk-team-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.activate(tab);
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next]);
        this.tabs[next].focus({ preventScroll: true });
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.activate(tab);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    activate(tab) {
      this.tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      const row = tab.parentElement;
      row.scrollTo({ left: tab.offsetLeft - row.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'auto' });
    }
  });
}
